import React from "react";

function Map() {
  return (
    <div className="min-[1200px]:h-[calc(100vh-390px)] h-[320px] max-[1200px]:h-[90vh] flex items-center flex-col justify-center bg-[url(/public/assets/home_bg.svg)] bg-cover bg-no-repeat bg-center">
      <img
        className="h-[50%] object-cover max-[1200px]:!h-[18%] "
        src="./assets/home_img.svg"
        alt=""
      />
    </div>
  );
}

export default Map;
